import { useState } from 'react';
import NavBar from './NavBar';
import "./WhatWeOffer.css";

function WhatWeOffer() {
    const [activeTab, setActiveTab] = useState(0);

    const portfolios = [
        {
            title: "Multi Asset Portfolios",
            description: "A diversified approach combining multiple asset classes to balance risk and return, suitable for investors seeking broad market exposure with built-in diversification."
        },
        {
            title: "Equity Portfolios",
            description: "Focused exposure to equity markets for investors seeking long-term capital growth, with careful selection of quality companies and active management."
        },
        {
            title: "Income Portfolios",
            description: "Designed for investors prioritising regular income generation, with a focus on dividend-paying equities, bonds, and other income-producing assets."
        }
    ];

    return (
        <div className="WhatWeOffer">
            <NavBar />

            <div className="PageTitleBanner">
                <h1>What We Offer</h1>
            </div>

            <div className="IntroText">
                <p>We aim to give you financial peace of mind by delivering a comprehensive wealth management service tailored to your unique goals and objectives. Our approach is built around a clear understanding of your needs and a disciplined investment process.</p>
            </div>

            <div className="PortfolioTabs">
                {portfolios.map((portfolio, index) => (
                    <button
                        key={index}
                        className={`PortfolioTab ${activeTab === index ? 'active' : ''}`}
                        onClick={() => setActiveTab(index)}
                    >
                        {portfolio.title}
                    </button>
                ))}
            </div>

            <div className="PortfolioContent">
                <h3>{portfolios[activeTab].title}</h3>
                <p>{portfolios[activeTab].description}</p>
            </div>

            <div className="ServicesSection">
                <div className="ServiceItem">
                    <div className="ServiceIcon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                        </svg>
                    </div>
                    <h4>Financial Planning</h4>
                    <p>Initial and ongoing needs analysis and financial planning to ensure your strategy evolves as your circumstances change.</p>
                </div>
                <div className="ServiceItem">
                    <div className="ServiceIcon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="12" cy="12" r="10" />
                            <path d="M2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" />
                        </svg>
                    </div>
                    <h4>Portfolio Management</h4>
                    <p>Advisory or discretionary portfolio management, both locally and offshore, aligned with your risk profile and return objectives.</p>
                </div>
                <div className="ServiceItem">
                    <div className="ServiceIcon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M4 6h16M4 12h16M4 18h7" />
                        </svg>
                    </div>
                    <h4>Asset Allocation</h4>
                    <p>Portfolio construction incorporating strategic and tactical asset allocation across major asset classes.</p>
                </div>
                <div className="ServiceItem">
                    <div className="ServiceIcon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
                            <polyline points="22 4 12 14.01 9 11.01" />
                        </svg>
                    </div>
                    <h4>Performance Monitoring</h4>
                    <p>Ongoing manager selection and performance monitoring to maintain quality, consistency, and accountability.</p>
                </div>
                <div className="ServiceItem">
                    <div className="ServiceIcon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
                            <polyline points="14 2 14 8 20 8" />
                            <line x1="16" y1="13" x2="8" y2="13" />
                            <line x1="16" y1="17" x2="8" y2="17" />
                        </svg>
                    </div>
                    <h4>Administration & Reporting</h4>
                    <p>Handling of all implementation, administration, and transparent reporting, allowing you to focus on what matters most while we manage the details.</p>
                </div>
            </div>
            <footer className="ComplianceFooter">
                <p>Oakmere Capital is a Juristic Representative of Yellowwood Private Wealth. Yellowwood Private Wealth is an authorised financial services provider.</p>
                <p>FSP No 49879</p>
                <p>Copies of our complaints and conflicts of interest policies are available upon request.</p>
            </footer>
        </div>
    )
}

export default WhatWeOffer;
